<template>
    <div>
        <el-dialog title="赛道规则" :visible.sync="dialogFormVisible"
                   :close-on-click-modal="false"
                   append-to-body class="dialogFormVisibleDialog">
            <el-form :model="track" :rules="rulesTrackSuccess" ref="rulesSuccessRef">
                <el-form-item label="赛道名称"  prop="name">
                    <el-input v-model="track.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="作品类别" prop="typeList" ref="typeList">
                    <div style="position: relative;">
                        <div>
                            <div v-for="(item,index) in track.typeList"  :key="index" class="modelHeightRangeClass">
                                <el-form-item :prop="'typeList.'+ index +'.name'" :rules="rulesTrackSuccess.typeList">
                                    <el-input v-model="item.worksType" placeholder="请输入作品类别" style="width: 500px;"></el-input>
                                </el-form-item>
                                <span v-if="index !== 0" style="padding-left: 30px;cursor: pointer;color: #157efb;line-height: 40px;" @click="delTrackNext(index)">删除</span>
                            </div>
                            <el-button class="addNext" type="primary" size="small" @click="addTrackType">点击添加下一条</el-button>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="投票占比"  prop="voteRatio">
                    <el-input v-model="track.voteRatio" @input="countVote" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="评委评分占比"  prop="judgesAppraisalRatio">
                    <el-input v-model="track.judgesAppraisalRatio" @input="countVote" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="奖项设置" prop="awardList" ref="awardList">
                    <div style="position: relative;">
                        <div>
                            <el-form-item :rules="rulesTrackSuccess.awardList">
                                <el-table
                                    border
                                    :data="track.awardList"
                                    style="width: 100%">
                                    <el-table-column
                                        prop="awardName"
                                        label="奖项名称">
                                    </el-table-column>
                                    <el-table-column
                                        prop="awardNumber"
                                        label="奖项人数">
                                    </el-table-column>
                                    <el-table-column
                                        prop="awardContent"
                                        label="奖品名称">
                                    </el-table-column>
                                    <el-table-column
                                        prop="awardUrl"
                                        label="奖项配图"
                                        align="center">
                                        <template slot-scope="scope">
                                            <img class="successImgsUrl" :src="scope.row.awardUrl">
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="address"
                                        label="操作">
                                        <template slot-scope="scope">
                                            <el-button  type="text" size="small" @click="updateTrackAwardInfo(scope.row,scope.$index)">修改</el-button>
                                            <el-button  type="text" size="small" @click="delTrackAwardsNext(scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                            <el-button class="addNext" type="primary" size="small" @click="addTrackAwardData">点击添加奖项</el-button>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitTrackInfo">确 定</el-button>
            </div>
            <track-award-dialog ref="trackAwardRefs" @submit="saveOrUpdateTrackAwardInfo"></track-award-dialog>
        </el-dialog>
    </div>
</template>

<script>
import trackAwardDialog from './trackAwardDialog';
export default {
    name: "trackDetailsDialog",
    data() {
        return {
            dialogFormVisible:false,
            track:{
                name:"",
                voteRatio:"",
                judgesAppraisalRatio:"",
                updateIndex:"",
                typeList:[],
                awardList:[],
            },
            rulesTrackSuccess:{
                name:[
                    {required: true, message: '请输入赛道名称', trigger: 'blur'}
                ],
                voteRatio:[
                    {required: true, message: '请输入投票占比', trigger: 'blur'}
                ],
                judgesAppraisalRatio:[
                    {required: true, message: '请输入评委评分占比', trigger: 'blur'}
                ],
                /*typeList:[
                    {required: true, message: '请增加作品类型', trigger: 'blur'}
                ],*/
                awardList:[
                    {required: true, message: '请增加赛道奖项', trigger: 'blur'}
                ]
            },
        }
    },
    components: {
        trackAwardDialog,
    },
    created(){

    },
    methods: {
        init(item){
            this.reset();
            if(item!==undefined&&item!==null){
                this.track = item;
            }
            this.dialogFormVisible = true;
        },
        reset(){
            this.track = {
                name:"",
                voteRatio:"",
                judgesAppraisalRatio:"",
                typeList:[],
                awardList:[],
            };
            this.$nextTick(() => {
                // DOM 更新了
                this.$refs["rulesSuccessRef"].clearValidate()
            });
        },
        submitTrackInfo(){
            this.$refs.rulesSuccessRef.validate((valid) => {
                if(valid){
                    // 保存数据
                    this.dialogFormVisible = false;
                    this.$emit("submit",this.track);
                }
            });
        },
        saveOrUpdateTrackAwardInfo(item){
            // 参数排序
            if(typeof item.updateIndex==='number'){
                // 直接赋值过去
                this.track.awardList[item.updateIndex] = item;
            }else{
                this.track.awardList.push({
                    awardName:item.awardName,
                    awardNumber:item.awardNumber,
                    awardContent:item.awardContent,
                    awardUrl:item.awardUrl,
                    sort:item.sort,
                });
            }
            this.track.awardList = this.compare(this.track.awardList,'sort');
        },
        // 排序
        compare(array, key) {
            return array.sort(function (a, b) {
                const x = a[key];
                const y = b[key];
                return ((x < y) ? -1 : (x > y) ? 1 : 0)
            });
        },
        // 新增作品类别
        addTrackType(){
            this.track.typeList.push({
                worksType: ''
            })
        },
        // 删除作品类别
        delTrackNext(index){
            this.track.typeList.splice(index,1)
        },
        addTrackAwardData(){
            this.$refs.trackAwardRefs.init();
        },
        updateTrackAwardInfo(item,index){
            item.updateIndex = index;
            this.$refs.trackAwardRefs.init(item);
        },
        delTrackAwardsNext(index){
            this.track.awardList.splice(index,1);
        },
        countVote(){
            let numReg = /^[0-9]*$/;
            let numRe = new RegExp(numReg);
            if (!numRe.test(this.track.voteRatio)) {
                this.$message.error("请输入数字");
                this.track.voteRatio = 0;
            }else if (this.track.voteRatio > 100) {
                this.$message.error("请输入小于或者等于100的参数");
                this.track.voteRatio = 100;
                this.track.judgesAppraisalRatio = 0;
            }else{
                this.track.judgesAppraisalRatio = 100 - Number(this.track.voteRatio);
            }
        },
    },
}
</script>

<style  scoped lang="less">
.modelHeightRangeClass{
    display: flex;
    margin-bottom: 25px;
    /deep/.el-form-item__content{
        margin-left: 0 !important;
    }
}
.dialogFormVisibleDialog {
    /deeep/.el-dialog__body {
        padding-left: 30px !important;
        padding-right: 30px !important;
    }
}
.awaedUrlImgs {
    /deep/.el-image {
        width: 125px;
        height: 154px;
    }
}
.successImgsUrl {
    cursor: pointer;
    color: #409EFF;
    width:100%;
}
/deep/.el-form-item__label{
    float: none;
}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/trackDetailsDialog.vue